import { StatsigEvent } from './types';
import { configBase } from '@/config/base';

export const eventIsTracked = (name: StatsigEvent) => {
    const events = configBase.tracking.enabled ? window.statsig : window.statsigDebug;
    return events && events?.findIndex((x) => (x as any).eventName === name) !== -1;
};

export const migrateOldSdkStableIdToNewSdk = () => {
    const OLD_KEY = 'STATSIG_LOCAL_STORAGE_STABLE_ID';
    const NEW_KEY = 'statsig.stable_id.3206961030';
    try {
        if (localStorage.getItem(OLD_KEY) && !localStorage.getItem(NEW_KEY)) {
            const oldValue = localStorage.getItem(OLD_KEY) as string;
            localStorage.setItem(NEW_KEY, oldValue);
        }
    } catch {
        // localStorage not available, not a problem
    }
};
